import { useState, useEffect } from 'react';
import api from '../../config/axios';
import { MdCheck, MdClose } from 'react-icons/md';
import { useLanguage } from '../../context/LanguageContext';

const AccountSettings = ({ onClose, userId }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    full_name: '',
    username: '',
    agent_email: '',
    agent_gsm: '',
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.get(`/agents/single/${userId}`);
        
        if (response.data.success) {
          const { full_name, username, agent_email, agent_gsm } = response.data.agent;
          setFormData(prev => ({
            ...prev,
            full_name,
            username,
            agent_email,
            agent_gsm
          }));
        }
      } catch (error) {
        setMessage({
          type: 'error',
          text: t('supportCase.userInfoLoadError')
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;

      const userData = JSON.parse(userStr);
      
      // Şifre değişikliği varsa kontrol et
      if (formData.new_password) {
        if (formData.new_password !== formData.confirm_password) {
          setMessage({
            type: 'error',
            text: t('supportCase.passwordMismatch')
          });
          return;
        }
      }

      const response = await api.put(
        `/agents/${userData.id}/account`,
        {
          full_name: formData.full_name,
          username: formData.username,
          agent_email: formData.agent_email,
          agent_gsm: formData.agent_gsm,
          current_password: formData.current_password,
          new_password: formData.new_password
        }
      );

             if (response.data.success) {
         // Başarı mesajını gösterme - popup yeterli
         setMessage({ type: '', text: '' });
        
        // Şifre alanlarını temizle
        setFormData(prev => ({
          ...prev,
          current_password: '',
          new_password: '',
          confirm_password: ''
        }));

        // LocalStorage'daki user bilgisini güncelle
        const updatedUser = {
          ...userData,
          fullName: formData.full_name,
          username: formData.username
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));

        // Her değişiklikte logout popup'ını göster
        setShowLogoutPopup(true);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || t('supportCase.updateError')
      });
    }
  };

  // Telefon girişi kontrolü - Sadece rakam
  const handlePhoneInput = (e, setter, formData, field) => {
    const value = e.target.value;
    
    // Sadece rakamları al
    const numbers = value.replace(/\D/g, '');
    
    // Maksimum 10 rakam
    if (numbers.length > 10) {
      return;
    }
    
    // Sadece rakamları kaydet
    setter({...formData, [field]: numbers});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
      <div className="relative mx-auto w-[600px] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
        {/* Header */}
        <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
          <h3 className="text-lg font-medium">
            {t('supportCase.accountSettings')}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-300 hover:text-white"
          >
            <MdClose size={24} />
          </button>
        </div>
        
        {/* Form Content */}
        <div className="p-6">
          {loading ? (
            <div className="text-center py-4">{t('supportCase.loading')}</div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 gap-4">
                {/* Profil Bilgileri */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    {t('supportCase.fullName')} *
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    {t('supportCase.username')} *
                  </label>
                  <input
                    type="email"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    {t('supportCase.email')} *
                  </label>
                  <input
                    type="email"
                    name="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                                 <div>
                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                     {t('supportCase.phone')} *
                   </label>
                   <input
                     type="tel"
                     name="agent_gsm"
                     value={formData.agent_gsm}
                     onChange={(e) => handlePhoneInput(e, setFormData, formData, 'agent_gsm')}
                     placeholder={t('supportCase.phonePlaceholder')}
                     className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                     inputMode="numeric"
                     pattern="[0-9]*"
                     required
                   />
                 </div>

                {/* Şifre Değiştirme (Opsiyonel) */}
                <div className="pt-4 border-t border-gray-200 dark:border-gray-600">
                  <div className="mb-3">
                    <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {t('supportCase.passwordChange')}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      {t('supportCase.passwordChangeDescription')}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      {t('supportCase.currentPassword')}
                    </label>
                    <input
                      type="password"
                      name="current_password"
                      value={formData.current_password}
                      onChange={handleChange}
                      autoComplete="new-password"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder={t('supportCase.currentPasswordPlaceholder')}
                    />
                  </div>

                  <div className="mt-3">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      {t('supportCase.newPassword')}
                    </label>
                    <input
                      type="password"
                      name="new_password"
                      value={formData.new_password}
                      onChange={handleChange}
                      autoComplete="new-password"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder={t('supportCase.newPasswordPlaceholder')}
                    />
                  </div>

                  <div className="mt-3">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      {t('supportCase.confirmPassword')}
                    </label>
                    <input
                      type="password"
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleChange}
                      autoComplete="new-password"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder={t('supportCase.confirmPasswordPlaceholder')}
                    />
                  </div>
                </div>

                {/* Mesaj gösterimi */}
                {message.text && (
                  <div className={`p-3 rounded-md ${
                    message.type === 'error' ? 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400' : 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400'
                  }`}>
                    <div className="flex items-center gap-2">
                      {message.type === 'success' && <MdCheck size={18} />}
                      <span className="text-sm">{message.text}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                >
{t('supportCase.update')}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* Logout Popup */}
      {showLogoutPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto p-8 border border-gray-200 dark:border-gray-700 w-[400px] shadow-lg rounded-md bg-white dark:bg-gray-800">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
              {t('supportCase.information')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
              {t('supportCase.accountUpdatedMessage')}
            </p>
            <div className="flex justify-end">
              <button
                onClick={() => {
                  localStorage.removeItem('token');
                  localStorage.removeItem('user');
                  window.location.href = '/admin';
                }}
                className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
              >
{t('supportCase.ok')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountSettings; 